const fallback = function (cb) {
  const start = Date.now();

  return setTimeout(function () {
    cb({
      didTimeout: false,
      timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
};

// to not break ssr
const isSupported =
  typeof window !== 'undefined' &&
  typeof window.requestIdleCallback !== 'undefined';

export default !isSupported ? fallback : window.requestIdleCallback;
